import { render, staticRenderFns } from "./AttentionSummaryDrawer.vue?vue&type=template&id=5f8dc4f0&scoped=true&"
import script from "./AttentionSummaryDrawer.vue?vue&type=script&lang=js&"
export * from "./AttentionSummaryDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AttentionSummaryDrawer.vue?vue&type=style&index=0&id=5f8dc4f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8dc4f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VNavigationDrawer})
